/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable object-shorthand */
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import styles from './Process.module.css' 
import { API } from '../../apis/api';
import {
  API_RESOURCE_URLS,
  HATEAOS_LINKS,
  USER_OPERATIONS,
  RESOURCE_TYPE,
} from '../../constants';
import { buildErrorMessage } from '../../apis/calls';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import {
  ProcessList,
  ProcessTabs,
  Panel,
  ProcessDetailsView,
  GridLoadingSpinner
} from '../../components';
import { getApiRelativeUrl } from '../../utils/utils';
import { Button, AuthChecker } from '../../atomicComponents';
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';
import { withAllowedOperationsProvider } from '../../hocs'

function Process() {
  const history = useHistory();
  const { user } = useAuthorizationContext();
  const { showInternalError } = usePopupManager();

  const [todoList, setTodoList] = useState({
    reload: false,
    loading: false,
    data: [],
    last: false,
    number: 0,
    totalElements: 0
  });

  const [overviewList, setOverviewList] = useState({
    reload: false,
    loading: false,
    data: [],
    last: false,
    number: 0,
    totalElements: 0
  });

  const [reload1, setReload] = useState(false);
  const [ppap, setPpap] = useState({ loading: false, data: {} });
  const [search, setSearchInput] = useState(null);

  const [selectedTab, setSelectedTab] = useState(0);
  const handleTabChange = (value) => {
    if (value === 0)
      setTodoList((prev) => ({
        ...prev,
        number: 0
      }))
    else
      setOverviewList((prev) => ({
        ...prev,
        number: 0
      }))
    setSelectedTab(value)
  };

  const [todoCount, setTodoCount] = useState(0);
  const setTodoListCount = (count) => {
    setTodoCount(count);
  };

  const [overviewCount, setOverviewCount] = useState(0);
  const setOverviewListCount = (count) => {
    setOverviewCount(count);
  };

  const getPpapDetailsForPpapId = async (url) => {
    try {
      setPpap({ loading: true, data: {} });
      const response = await API.get(url);
      const { data: ppapResponseFromApi } = response;
      setPpap({loading: false, data: ppapResponseFromApi });
    } catch(error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setPpap({ loading: false, data: {} });
    }
  }

  const redirectToCreateProcess = () => {
    history.push('/create-process');
  };

  const handleClick = (index, list, setState) => {
    setState((prev) => ({
      ...prev,
      data: prev.data.map((item, idx) => {
        if (idx === index) {
          return { ...item, isSelected: true };
        }
        return { ...item, isSelected: false };
      })
    })) 
    const { href } = list[index].links.find(
      ({ rel }) => rel === HATEAOS_LINKS.PPAP || rel === "self"
    );
    const url = getApiRelativeUrl(href);
    getPpapDetailsForPpapId(url);
  }

  const tabs = [
    {
      label: 'To Do List',
      title: 'To Do List',
      count: todoCount,
      component: ProcessList,
      props: {
        data: todoList.data,
        pagination: {
          last: todoList.last,
          setState: setTodoList
        },
        handleClick,
        searchInput: (e) => {setSearchInput(e)}
      }
    },
    {
      label: 'Overview',
      title: 'Overview',
      count: overviewCount,
      component: ProcessList,
      props: {
        data: overviewList.data,
        pagination: {
          last: overviewList.last,
          setState: setOverviewList
        },
        handleClick,
        searchInput: (e) => {setSearchInput(e)}
      }
    },
  ]

  const processTodoData = (data) => {
    let processedData = {};

    const processedList = data.content.map((item) => ({
      ...item,

      name: item.description,
      isSelected: false
    }))

    processedData = {
      ...data,
      content: processedList
    }

    return processedData;
  }

  const getTodoList = async () => {
		try {
			setTodoList((prev) => ({
				...prev,
				loading: true,
			}));
			if (!search || search === null) {
				const response = await API.get(API_RESOURCE_URLS.TASKS, {
					params: {
						page: todoList.number,
						size: 20,
					},
				});

				const { data: todoListFromApi } = response;
				const processedTodoData = processTodoData(todoListFromApi);
				const { content, last, totalElements } = processedTodoData;

				setTodoList((prev) => ({
					...prev,
					reload: false,
					data:
						todoList.number !== 0 ? [...prev.data, ...content] : [...content],
					loading: false,
					last,
					totalElements,
				}));
			} else if (search && selectedTab === 0) {
				const response = await API.get(API_RESOURCE_URLS.PPAP_TASKS, {
					params: {
						ppapId: search || undefined,
					},
				});
				const { data } = response;
				setTodoList({
					reload: false,
					data: data,
					loading: false,
					last: false,
					number: 0,
					totalElements: data.length,
				});
			}
		} catch (error) {
			showInternalError(error);
			console.error(buildErrorMessage(error));
			setTodoList({
				reload: false,
				data: [],
				loading: false,
				last: false,
				number: 0,
				totalElements: 0,
			});
		}
	};
  const reloadTodoListAndreloadOverviewList = (list = []) => {
    if(list[0]){
    const { href } = list[0].links.find(
      ({ rel }) => rel === HATEAOS_LINKS.PPAP || rel === "self"
    );
    const url = getApiRelativeUrl(href);
    getPpapDetailsForPpapId(url);
    }
  };

  const reloadTododList = async () => {
    try {
      const response = await API.get(API_RESOURCE_URLS.TASKS, {
        params: {
          page: todoList.number,
          size: 20,
        },
      });
      const { data: todoListFromApi } = response;
      const processedTodoData = processTodoData(todoListFromApi);
      const { content, totalElements, last } = processedTodoData;

      let list = [];

      setTodoList((prev) => {
        list =
          todoList.number !== 0
            ? [...prev.data, ...content].map((item, idx) => {
                if (idx === 0 && selectedTab === 0) {
                  return { ...item, isSelected: true };
                }
                return { ...item, isSelected: false };
              })
            : [...content].map((item, idx) => {
                if (idx === 0) {
                  return { ...item, isSelected: true };
                }
                return { ...item, isSelected: false };
              });
        return {
          ...prev,
          reload: false,
          data: list,
          loading: false,
          totalElements,
          last,
        };
      });
      if (selectedTab === 0) {
        reloadTodoListAndreloadOverviewList(list);
      }
    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setTodoList({
        reload: false,
        data: [],
        loading: false,
        number: 0,
        totalElements: 0,
      });
    }
  };
  const processOverviewData = (data) => {
    let processedData = {};

    const processedList = data.content.map((item) => ({
      ...item,
      ppapId: item.id,
      projectCode: item.project.code,
      partNumber: item.part.number,
      commodity: item.commodityGroup,
      supplierCode: item.supplier.code,
      isSelected: false,
    }));
    processedData = {
      ...data,
      content: processedList,
    };

    return processedData;
  };

  const getOverviewList = async () => {
		try {
			setOverviewList((prev) => ({
				...prev,
				loading: true,
			}));
			if (!search || search === null) {
				const response = await API.get(
					!user.supplierId
						? API_RESOURCE_URLS.PPAP
						: API_RESOURCE_URLS.getSupplierListOfPpap(user.supplierId),
					{
						params: {
							page: overviewList.number,
							size: 20,
						},
					},
				);

				const { data: overviewListFromApi } = response;
				const processedOverviewData = processOverviewData(overviewListFromApi);
				const { content, last, totalElements } = processedOverviewData;

				setOverviewList((prev) => ({
					...prev,
					reload: false,
					data:
						overviewList.number !== 0
							? [...prev.data, ...content]
							: [...content],
					loading: false,
					last,
					totalElements,
				}));
			} else if (search && selectedTab === 1) {
				const response = await API.get(API_RESOURCE_URLS.getPpap(search));
				const { data } = response;
        const { _links:links } = data;
				const tempList =
					data && data.id
						? [
								{
									...data,
									ppapId: data.id,
									projectCode: data.project.code,
									partNumber: data.part.number,
									commodity: data.commodityGroup,
									supplierCode: data.supplier.code,
									isSelected: false,
                  links: [
                    {href:links?.self?.href, rel: "self"}
                  ]
								},
						  ]
						: [];

				setOverviewList({
					reload: false,
					data: tempList,
					loading: false,
					last: false,
					number: 0,
					totalElements: 1,
				});
			}
		} catch (error) {
			showInternalError(error);
			console.error(buildErrorMessage(error));
			setOverviewList({
				data: [],
				loading: false,
				last: false,
				number: 0,
				totalElements: 0,
			});
		}
	};

  const reloadOverviewList = async () => {
    try {
      const response = await API.get(
        !user.supplierId
          ? API_RESOURCE_URLS.PPAP
          : API_RESOURCE_URLS.getSupplierListOfPpap(user.supplierId),
        {
          params: {
            page: overviewList.number,
            size: 20,
          },
        }
      );
      const { data: overviewListFromApi } = response;

      const processedOverviewData = processOverviewData(overviewListFromApi);

      const { content, last, totalElements } = processedOverviewData;

      let list = [];

      setOverviewList((prev) => {
        list =
          overviewList.number !== 0
            ? [...prev.data, ...content].map((item, idx) => {
                if (idx === 0 && selectedTab === 1) {
                  return { ...item, isSelected: true };
                }
                return { ...item, isSelected: false };
              })
            : [...content].map((item, idx) => {
                if (idx === 0) {
                  return { ...item, isSelected: true };
                }
                return { ...item, isSelected: false };
              });
        return {
          ...prev,
          reload: false,
          data: list,
          loading: false,
          totalElements,
          last,
        };
      });
      if (selectedTab === 1) {
        reloadTodoListAndreloadOverviewList(list);
      }
    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setOverviewList({
        reload: false,
        data: [],
        loading: false,
        number: 0,
        totalElements: 0,
      });
    }
  };
  useEffect(() => {
    getTodoList();
  }, [todoList.number, search]);

  useEffect(() => {
    getOverviewList();
  }, [overviewList.number, search]);

  useEffect(() => {
    if (reload1 === true) {
      reloadTododList();
      reloadOverviewList();
      setReload(false);
    }
  }, [reload1]);

  useEffect(() => {
    if (selectedTab === 0) {
      reloadTododList();
    }
    if (selectedTab === 1) {
      reloadOverviewList();
    }
  }, [selectedTab]);

  useEffect(() => {
    setTodoListCount(todoList.totalElements);
  }, [todoList.totalElements]);

  useEffect(() => {
    setOverviewListCount(overviewList.totalElements);
  }, [overviewList.totalElements]);

  return (
    <div className={styles.container}>
      <div className={styles.processListView}>
        <div className={styles.tabsContainer}>
          <ProcessTabs
            tabs={tabs}
            selectedTab={selectedTab}
            handleTabChange={handleTabChange}
          />
        </div>
        <div className={styles.content}>
          {tabs.map((tab, index) => (
            <Panel value={selectedTab} index={index}>
              <tab.component {...tab.props} />
            </Panel>
          ))}
        </div>
        <div className={styles.actionBar}>
          <AuthChecker operation={USER_OPERATIONS.CREATE_PPAP}>
            {(isAuthorized) =>
              isAuthorized && (
                <Button
                  className={styles.actionButton}
                  variant="tertiary"
                  onClick={redirectToCreateProcess}
                >
                  New Process
                </Button>
              )
            }
          </AuthChecker>
        </div>
      </div>
      <ProcessDetailsView
        ppap={ppap}
        setReload={setReload}
        setTodoList={setTodoList}
        setOverviewList={setOverviewList}
      />
      {ppap.loading && (
        <div className={styles.gridLoader}>
          <GridLoadingSpinner />
        </div>
      )}
    </div>
  );
}

export default withAllowedOperationsProvider(Process, RESOURCE_TYPE.PPAP);
